import { render } from "./NotificationsHeader.vue?vue&type=template&id=c9803a60&scoped=true"
import script from "./NotificationsHeader.vue?vue&type=script&lang=js"
export * from "./NotificationsHeader.vue?vue&type=script&lang=js"

import "./NotificationsHeader.vue?vue&type=style&index=0&id=c9803a60&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9803a60"]])

export default __exports__